import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen component"
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-3xl lg:text-5xl font-bold inline border-b-4 border-red-700">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-2xl lg:text-4xl font-bold">
            <p>Software Engineer with 3 years of experience.</p>
          </div>
          <div className="my-auto">
            My background spans a total of 10 years across Retail, HR tech,
            Martech, and UI/UX design. Having diverse experience in Sales,
            Solutioning, and Engineering -- I am passionate about transforming
            businesses with elegant user-centric design.
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
